<template>

    <div class="payment-transection" :class="paymentHistory.length !=0 ? '':'payment-transection-background'">
        <div class="container">
            <div class="payment-card__btn mb-3" >
                <search-bar :placeholder="placeholder"
                            :btnText="buttonTitle"
                            class="row"
                            @applySearch="getData"></search-bar>
                <button class="custom-btn" @click="Reset">{{resetButton}}</button>
            </div>
            <div class="payment-card  " v-for="(item, index) in paymentHistory" :key="index">
                <div class="payment-card__date">
                    {{ new Date(item.PaymentDate).toLocaleDateString(culture,{ weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) }}
                </div>
                <div class="payment-card__wrapper">
                    <div class="payment-card__wrapper__item">
                        <div class="payment-card__wrapper__item__title">
                            {{ orderNumber }}
                        </div>
                        <div class="payment-card__wrapper__item__description">
                            {{ item.PaymentOrderNumber }}
                        </div>
                    </div>
                    <div class="payment-card__wrapper__item">
                        <div class="payment-card__wrapper__item__title">
                            {{ orderSatuts }}
                        </div>
                        <div class="payment-card__wrapper__item__description">
                            {{ item.TransactionStatus }}
                        </div>
                    </div>
                    <div class="payment-card__wrapper__item">
                        <div class="payment-card__wrapper__item__title">
                            {{ orderDate }}
                        </div>
                        <div class="payment-card__wrapper__item__description">
                            {{new Date(item.OrderDate).toLocaleString(culture) }}
                        </div>
                    </div>
                    <div class="payment-card__wrapper__item">
                        <div class="payment-card__wrapper__item__title">
                            {{ orderReceiptNumber }}
                        </div>
                        <div class="payment-card__wrapper__item__description">
                            {{ item.ReceiptNumber || '-' }}
                        </div>
                    </div>
                    <div class="payment-card__wrapper__item">
                        <div class="payment-card__wrapper__item__title">
                            {{ serviceName }}
                        </div>
                        <div class="payment-card__wrapper__item__description">
                            {{ item.ServiceName }}
                        </div>
                    </div>
                    <div class="payment-card__wrapper__item">
                        <div class="payment-card__wrapper__item__title">
                            {{ amountPaid }}
                        </div>
                        <div class="payment-card__wrapper__item__description">
                            {{ item.PaymentAmount }} {{ EgyptianPoundLabel }}
                        </div>
                    </div>
                </div>
                <div class="payment-card__btn" v-if="item.TransactionStatus=='Successful' || item.TransactionStatus=='ناجحه'">
                    <a class="custom-btn" :href="paymentReceiptUrl+item.PaymentOrderNumber+'?sessionId='+paymentSessionId+ '&requestorId='+userId">{{ orderDetails }}</a>
                </div>
            </div>
            <div v-if="paymentHistoryError" class="empty-msg">
                <p>{{ paymentHistoryErrorMessage }}</p>
            </div>
            <div class="generic-listing-loader" v-if="isAjaxLoading">
                <img src="../../../Assets/Images/spinner.svg" alt="EDA Spinner">
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import moment from 'moment';
    import SearchBar from "../../../src/components/SearchBar/SearchBar.vue";
    let baseUrl = document.location.origin;
    let apiUrl = baseUrl + "";
    export default {
        props: {
            orderNumber: {
                type: String
            },
            paymentHistoryErrorMessage: {
                type: String
            },
            orderSatuts: {
                type: String
            },
            orderDate: {
                type: String
            },
            orderReceiptNumber: {
                type: String
            },
            orderExpirationDate: {
                type: String
            },
            serviceName: {
                type: String
            },
            amountPaid: {
                type: String
            },
            orderDetails: {
                type: String
            },
            EgyptianPoundLabel: {
                type: String
            },
            paymentReceiptUrl: {
                type: String
            },
            url: {
                type: String
            },
            lang: {
                type: String
            },
            culture: {
                type: String
            },
            paymentGetTransactionsByPaymentNumberUrl: {
                type: String
            },
            resetButton: {
                type: String
            },
            placeholder: {
                type: String
            },
            buttonTitle: {
                type: String
            }

        },
        data() {
            return {
                info: null,
                arrApiResp: [],
                pageNumber: 1,
                token: "",
                userId: null,
                paymentHistory: [],
                paymentHistoryError: false,
                isAjaxLoading: false,
                paymentSessionId: '',
                isSearch: false
            };
        },
        components: {
            SearchBar
        },
        methods: {
            getData(searchInput) {
                this.isAjaxLoading = true
                this.paymentSessionId = localStorage.getItem('paymentSession')
                this.arrApiResp = []
                this.isSearch = true
                axios
                    .get(`${this.paymentGetTransactionsByPaymentNumberUrl}?sessionid=${this.paymentSessionId}&RequestorID=${this.userId}&PaymentNumber=${searchInput}&lang=${this.lang}`)
                    .then((response) => {
                        this.isAjaxLoading = false;
                        this.paymentHistory = [response.data];
                    })
                    .catch((error) => {
                        if (error.response?.status == 403 || error.response?.status == 401) {
                            axios.get(`/umbraco/surface/users/CreatePaymentSession`).then((response) => {
                                localStorage.setItem('paymentSession', response.headers['payment.session'].replaceAll('"', ''))
                                this.paymentSessionId = localStorage.getItem('paymentSession')
                            }).then(() => {
                                this.getData(searchInput)
                            })
                        }
                        else {
                            console.log(error)
                        }
                    });
            },
            getPaymentHistory() {
                this.isSearch = false;
                this.isAjaxLoading = true
                if (this.pageNumber != 1) {
                    this.isAjaxLoading = true
                }
                this.paymentSessionId = localStorage.getItem('paymentSession')
                this.arrApiResp = []
                axios
                    .get(`${this.url}?sessionid=${this.paymentSessionId}&RequestorID=${this.userId}&pageNumber=${this.pageNumber}&lang=${this.lang}`)
                    .then((response) => {
                        this.isAjaxLoading = false;
                        this.arrApiResp = response.data;
                        if (this.arrApiResp.length != 0) {
                            this.slice();
                        } else {
                            if (this.paymentHistory.length == 0) {
                                this.paymentHistoryError = true;
                            } else {
                                this.paymentHistoryError = false;
                            }
                            this.arrApiResp = []
                        }
                    })
                    .catch((error) => {
                        if (error.response?.status == 403 || error.response?.status == 401) {
                            axios.get(`/umbraco/surface/users/CreatePaymentSession`).then((response) => {
                                localStorage.setItem('paymentSession', response.headers['payment.session'].replaceAll('"', ''))
                                this.paymentSessionId = localStorage.getItem('paymentSession')
                            }).then(() => {
                                this.getPaymentHistory()
                            })
                        }
                        else {
                            console.log(error)
                        }
                    });
            },
            Reset() {
                this.paymentHistory = [];
                this.pageNumber = 1;
                this.getPaymentHistory();
            },
            getUserInfo() {
                let token = localStorage.getItem("token")
                if (token != "") {
                    let headers = {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': "application/json",
                        },
                    };
                    let key = {
                        key: "value"
                    };
                    axios
                        .post(`${apiUrl}/Umbraco/Surface/Users/GetUserProfile`, key, headers)
                        .then((response) => {
                            this.userId = response.data.ProfileID;
                        }).then(() => {
                            this.getPaymentHistory();
                        }).then(() => {
                            document.querySelector('.generic-component-loader__img').style.display = "none";
                        })
                        .catch(() => {
                        });
                } else {
                    this.userId = null;
                }
            },
            slice() {
                this.paymentHistory = this.paymentHistory.concat(this.arrApiResp);
                this.paymentHistory.map(x => {
                    x.ServiceName = decodeURIComponent(escape(window.atob(x.ServiceName)));
                    x.ServiceCode = decodeURIComponent(escape(window.atob(x.ServiceCode)));
                    x.RequestorName = decodeURIComponent(escape(window.atob(x.RequestorName)));
                    x.OrderDate = moment(x.PaymentDate).format("HH:mm:ss YYYY-MM-DD");
                    x.PaymentDate = moment(x.PaymentDate).format("dddd, DD MMMM, YYYY");
                });
            },
            checkTrigger() {
                const observeroptions = {
                    threshold: 0.1,
                };
                const footerCheck = document.querySelector(".footer");
                const infiniteScrollObserver = (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            setTimeout(() => {
                                if (this.arrApiResp.length != 0 && !this.isSearch) {
                                    this.pageNumber += 1;
                                    this.getPaymentHistory();
                                }
                            }, 500);
                        }
                    });
                };

                const observerInit = new IntersectionObserver(infiniteScrollObserver, observeroptions);
                observerInit.observe(footerCheck);
            },
            getCookie(cname) {
                var name = cname + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(";");
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == " ") {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            }
        },
        beforeMount() {
            let token = localStorage.getItem("token");
            //if (sessionStorage.getItem("token")) {
            //    token = sessionStorage.getItem("token")
            //} else {
            //    token = localStorage.getItem("token")
            //}
            if (token == "") {
                window.location.href = apiUrl;
            }
            let lang = 'ar'
            if (location.pathname.includes('/en')) {
                lang = 'en'
            }
            moment.locale(lang);
            this.getUserInfo();
        },
        mounted() {
            this.checkTrigger()
        },
    };
</script>
